'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.Item = Item;

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Item(attr) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!_config2.default.models) {
    return attr;
  }

  var id = attr.id,
      others = (0, _objectWithoutProperties3.default)(attr, ['id']);
  var jobId = options.jobId,
      orderId = options.orderId;


  return (0, _extends3.default)({
    id: id,
    jobId: jobId,
    orderId: orderId
  }, others);
}

exports.default = Item;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/models/item.js
// module id = 1079
// module chunks = 0